export default "https://storage.googleapis.com/prepweb-prod/dist/4264bdafe3854fc3f25129c5a06534af.svg";